export default {"src":"/_next/static/media/1c.1de0422e.svg","height":136,"width":278,"blurWidth":0,"blurHeight":0};